import React, { useEffect, useState } from 'react';
import axios from 'axios';

function ReceivedLog() {
  const [logs, setLogs] = useState([]);
  const [query, setQuery] = useState('');
  const [expandedLogId, setExpandedLogId] = useState(null);

  const fetchLogs = async (q = '') => {
    const { data } = await axios.get('/api/v1/po-received-logs', { params: { q } });
    setLogs(data);
  };

  useEffect(() => {
    fetchLogs('');
  }, []);

  // Debounce search
  useEffect(() => {
    const handle = setTimeout(() => {
      fetchLogs(query.trim());
    }, 300);
    return () => clearTimeout(handle);
  }, [query]);

  const toggleExpand = (id) => {
    setExpandedLogId(expandedLogId === id ? null : id);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleString();
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">PO Received Log</h1>
      
      <div className="mb-4 flex items-center gap-2">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search by PO number..."
          className="border rounded p-2 w-full max-w-xl"
        />
      </div>
      
      <div className="space-y-4">
        {logs.length === 0 ? (
          <p className="text-gray-500">No receiving logs found.</p>
        ) : (
          logs.map((log) => (
            <div key={log.id} className="border rounded-lg overflow-hidden">
              {/* Log Header - Clickable */}
              <div 
                className="bg-gray-50 p-4 cursor-pointer hover:bg-gray-100 transition-colors"
                onClick={() => toggleExpand(log.id)}
              >
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <div className="flex items-center gap-3">
                      <span className="text-xl font-bold">
                        {log.purchaseOrder?.po_number || 'Unknown PO'}
                      </span>
                      <span className="text-sm text-gray-500">
                        {log.purchaseOrder?.Vendor?.vendor_name || ''}
                      </span>
                    </div>
                    <div className="text-sm text-gray-600 mt-1">
                      Received: {formatDate(log.date_received)}
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="flex items-center gap-4">
                      <div>
                        <span className="text-sm text-gray-500">Scanned:</span>
                        <span className="ml-1 font-semibold">{log.total_scanned || 0}</span>
                      </div>
                      <div>
                        <span className="text-sm text-gray-500">Matched:</span>
                        <span className="ml-1 font-semibold text-green-600">{log.total_matched || 0}</span>
                      </div>
                      <div className="text-gray-400">
                        {expandedLogId === log.id ? '▼' : '▶'}
                      </div>
                    </div>
                    <div className="text-sm text-gray-500 mt-1">
                      By: {log.packer?.full_name || log.packer?.email || 'Unknown'}
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Expanded Details */}
              {expandedLogId === log.id && (
                <div className="p-4 border-t">
                  <h4 className="font-semibold mb-2">Items Received</h4>
                  <table className="min-w-full text-sm border">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="p-2 border text-left">SKU</th>
                        <th className="p-2 border text-left">Product</th>
                        <th className="p-2 border text-right">Expected</th>
                        <th className="p-2 border text-right">Scanned</th>
                        <th className="p-2 border text-right">Variance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(log.items || []).map((item, idx) => {
                        const variance = (item.scanned_quantity || 0) - (item.expected_quantity || 0);
                        return (
                          <tr key={idx} className="border-t">
                            <td className="p-2 border font-mono">{item.product?.sku || ''}</td>
                            <td className="p-2 border">{item.product?.name || ''}</td>
                            <td className="p-2 border text-right">{item.expected_quantity || 0}</td>
                            <td className="p-2 border text-right">{item.scanned_quantity || 0}</td>
                            <td className={`p-2 border text-right font-semibold ${
                              variance === 0 ? 'text-green-600' : 
                              variance < 0 ? 'text-orange-600' : 'text-blue-600'
                            }`}>
                              {variance > 0 ? '+' : ''}{variance}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  
                  {log.notes && (
                    <div className="mt-3">
                      <span className="font-semibold">Notes:</span>
                      <p className="text-gray-600">{log.notes}</p>
                    </div>
                  )}
                  
                  <div className="mt-3 text-xs text-gray-400">
                    Log ID: {log.id} | Created: {formatDate(log.created_at)}
                  </div>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default ReceivedLog;
